module.exports = __webpack_public_path__ + "static/media/AMS_Logo2.fa987479.png";